export const Crud = {
    LIST: "list",
    ADD: 'add',
    EDIT: 'edit',
    REMOVE: 'remove'
};